import './bootstrap';
import './plugins';
import app from './app';
import './core/coreApp';
import store from './store/Index'
import './common/Translator'
import './common/Helper/helpers'
import './common/commonComponent'
import './tenant/tenantComponent'
import "./tenant/punchAlert";

app.use(store);
app.mount('#app');
